import React from 'react';
import { IBaseProps } from 'lib/data/interfaces';
import { ComponentTemplate, EntryGroupTemplate, ListingGroupTemplate, SectionTemplate, MetadataTemplate } from 'lib/data/model';
import { MiniTemplateCard } from 'components/general/TemplateCard';
import { IconType } from 'lib/data/model/dictionaries/IconTypes';
import "./GenericTemplateSelector.less";
import { ComponentNames } from 'lib/data/model/dictionaries/ComponentNames';
import { TemplateSelectorGroup } from './TemplateSelectorGroup';

interface IGenericTemplateSelectorSingleProps extends IBaseProps {
	genericComponentTemplates: ComponentTemplate[];
	templateSelected: (template: ComponentTemplate) => void;
	hideOptions?: boolean;
	noSectionTemplate?: boolean;
}
interface IGenericTemplateSelectorSingleState {

}

class SelectedTemplate {
	public template!: ComponentTemplate;
}

class NewSelectedTemplate extends SelectedTemplate {

	constructor(key: number, genericTemplates: ComponentTemplate[]) {

		super();

		this.template = genericTemplates[key];
	}
}

class GenericSelectedTemplate extends SelectedTemplate {

	constructor(templateType: string) {

		super();

		switch (templateType) {
			case "SectionTemplate":
				const sectionTemplate = new SectionTemplate;
				sectionTemplate.name = "New " + ComponentNames[templateType];
				sectionTemplate.requirements = [];
				this.template = sectionTemplate;
				break;
			case "EntryGroupTemplate":
				const entryGroupTemplate = new EntryGroupTemplate;
				entryGroupTemplate.name = "New " + ComponentNames[templateType];
				entryGroupTemplate.requirements = [];
				entryGroupTemplate.isReusable = false;
				entryGroupTemplate.canReorderChildren = true;
				this.template = entryGroupTemplate;
				break;
			case "ListingGroupTemplate":
				const listingGroupTemplate = new ListingGroupTemplate;
				listingGroupTemplate.name = "New " + ComponentNames[templateType];
				listingGroupTemplate.isReusable = false;
				listingGroupTemplate.canReorderChildren = true;
				this.template = listingGroupTemplate;
				break;
			default:
				break;
		}
	}
}


export class GenericTemplateSelectorSingle extends React.Component<IGenericTemplateSelectorSingleProps, IGenericTemplateSelectorSingleState> {

	public render() {

		const newTemplateTypes = (
			this.props.noSectionTemplate
				?
				[
					"EntryGroupTemplate",
					"ListingGroupTemplate"
				]
				:
				[
					"SectionTemplate",
					"EntryGroupTemplate",
					"ListingGroupTemplate"
				]
		);

		return (

			<div className="generic-template-selector">
				<div className="template-selector-group">
					{newTemplateTypes.map((templateType, key) =>
						<MiniTemplateCard
							onClick={() => this.props.templateSelected(new GenericSelectedTemplate(templateType).template)}
							key={key}
							className={"new-template-mini-cards"}
							title={`New ${ComponentNames[templateType]}`}
							iconType={IconType.get(templateType)} />)}
				</div>

				{
					this.props.hideOptions
						?
						null
						:
						<TemplateSelectorGroup
							titleBarText="Options:"
							componentList={this.props.genericComponentTemplates}
							onCardClick={(key) => this.props.templateSelected(new NewSelectedTemplate(key, this.props.genericComponentTemplates).template)}
						/>
				}
			</div>
		);
	}
}
